import React from 'react';
import { components } from 'react-select';
import { ArrowDropDown } from '@material-ui/icons';

export const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDropDown htmlColor="#2E4063" fontSize="small" />
    </components.DropdownIndicator>
  );
};
const controlStyles = {
  display: 'flex',
  background: '#ededf6',
  borderRadius: 18,
  heigth: 36,
  width: 'max-content',
};

export const ControlComponent = (props: any) => (
  <div style={controlStyles}>
    {/* <p>Custom Control</p> */}
    <components.Control {...props} />
  </div>
);

export const customStyles = {
  control: () => ({
    // none of react-select's styles are passed to <Control />
    display: 'flex',
    background: '#F7F7F7',
    borderRadius: 18,
    heigth: 36,
    cursor: 'pointer',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: 'transparent',
    color: '#2E4063',
    display: 'block',
    fontSize: 'inherit',
    padding: '8px 15px',
    width: '100%',
    boxSizing: 'border-box',
    cursor: 'pointer',
    ':hover': {
      ...provided[':hover'],
      backgroundColor: '#2E4063',
      color: 'white',
      path: {
        fill: 'white',
      },
    },
  }),
  input: (provided: any) => ({
    ...provided,
    padding: '0px 8px',
    margin: 0,
    paddingBottom: 0,
    paddingTop: 0,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    marginLeft: 10,
    color: '#2E4063',
    fontWeight: 'bold',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: 16,
    boxShadow: '0px 1px 14px rgba(0, 0, 0, 0.12)',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  singleValue: (provided: any) => ({
    ...provided,
    backgroundColor: 'transparent',
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '17px',
    letterSpacing: '0.25px',
    color: '#2E4063',
    marginLeft: '10px',
    textTransform: 'capitalize',
    width: 'max-content',
    fontWeight: 'bold',
  }),
};
